import type { Breadcrumb, Scope, User } from '@sentry/core'
import * as Sentry from '@sentry/vue'

type BreadcrumbInput = Breadcrumb
type UserInput = User | null

export function captureSentryException(error: unknown): string {
    return Sentry.captureException(error)
}

export function captureSentryExceptionWithScope(error: unknown, configureScope: (scope: Scope) => void): string {
    let eventId = ''

    Sentry.withScope((scope) => {
        configureScope(scope)
        eventId = Sentry.captureException(error)
    })

    return eventId
}

export function setSentryUser(user: UserInput): void {
    Sentry.setUser(user)
}

export function addSentryBreadcrumb(breadcrumb: BreadcrumbInput): void {
    Sentry.addBreadcrumb(breadcrumb)
}
